import axios from "axios";
import React, {Component} from "react";
import Modal from "react-bootstrap/Modal";
import FeatherIcon from 'feather-icons-react';
import Select from 'react-select';
import { toast } from "react-toastify";

class   BookForm extends Component{

    state = {
        id : null,
        staffId : "",
        studentId : "",
        bookId : "",
        date_start : "",
        date_end : "",
        reason : "",
        error : "",
        
        isModal : false,
        isStudent : true,
        books : [],
        students : [],
        staffs : [],
    }

    handleInput = (e) => {
        this.setState({
            [e.target.name]: e.target.value
        }); 
    }

    handleInputM = (e) => {
        this.setState({
            isStudent : !this.state.isStudent
        }); 
    }

    async books (){
        var books = await axios.get('books');
        if(books.status === 200)
        {
            this.setState({
                books : books.data
            })
        }
    }

    async students (){
        var students = await axios.get('students');
        if(students.status === 200)
        {
            this.setState({
                students : students.data
            })
        }
    }

    async staffs (){
        var staffs = await axios.get('staffs');
        if(staffs.status === 200)
        {
            this.setState({
                staffs : staffs.data
            })
        }
    }

    storeBorrow = () =>{
        var data = {
                staffId : this.state.staffId ? this.state.staffId : null,
                studentId : this.state.studentId ? this.state.studentId : null,
                bookId : this.state.bookId ? this.state.bookId : null,
                date_start : this.state.date_start,
                date_end : this.state.date_end,
                reason : this.state.reason,
            }
            
        var request = this.state.id ? axios.put('borrows/'+this.state.id, data) : axios.post('borrows', data);
        request.then((response) =>{
            this.props.showModal()
            toast(response?.data?.msg, { theme : "light", style : { backgroundColor : "blue", color : "white"}})
        }).catch((error) => {
            this.setState({
                error : error.response.data.msg
            })
            toast(error.response?.data?.msg, { theme : "light", style : { backgroundColor : "red", color : "white"}})
        })
    }
    
    edit=()=>  {
        this.form()
        this.students()
        this.staffs()
        this.books()
    }

    form=()=>{
        var date_start = this.props.formData ?  new Date(this.props.formData.date_start) : new Date();
        var mois = date_start.getMonth()+1;
            mois = mois >= 10 ? mois : "0"+mois;
        var jour = date_start.getDate() >= 10 ? date_start.getDate() : "0"+date_start.getDate();
        date_start = date_start.getFullYear()  + "-" + (mois) + "-" + jour;

        var date_end = this.props.formData ?  new Date(this.props.formData.date_end) : new Date();
        mois = date_end.getMonth()+1;
            mois = mois >= 10 ? mois : "0"+mois;
        jour = date_end.getDate() >= 10 ? date_end.getDate() : "0"+date_end.getDate();
        date_end = date_end.getFullYear()  + "-" + (mois) + "-" + jour;


        this.setState({
            id: this.props.formData ? this.props.formData.id : "",
            staffId: this.props.formData ? this.props.formData.staff ? this.props.formData.staff.id : null : null,
            studentId: this.props.formData ? this.props.formData.student ? this.props.formData.student.id : null : null,
            bookId: this.props.formData ? this.props.formData.book ? this.props.formData.book.id : null : null,
            date_start: date_start,
            date_end: date_end,
            reason: this.props.formData ? this.props.formData.reason : "",
            error : "",
        })
    }

    showModal = () => {
        this.setState({
            isModal : !this.state.isModal,
        })
    }

    render(){
        var optionbooks = [], optionstudents = [], optionstaffs = [];

        this.state.books.map((book) => {
            optionbooks.push({ value : book.id, label : book.title + " " + book.spot.spot})
        })

        this.state.students.map((student) => {
            optionstudents.push({ value : student.id, label : student.matricule + " " + student.user.last_name + " " + student.user.first_name})
        })

        this.state.staffs.map((staff) => {
            optionstaffs.push({ value : staff.id, label : staff.matricule + " " + staff.user.last_name + " " + staff.user.first_name})
        })
        
        return(
            <div>
            <Modal 
                show={this.props.isModal} 
                onHide={this.props.showModal}
                size="lg"
                onEntered={this.edit}
                backdrop={"static"}>
                <Modal.Header>
                    <Modal.Title className="h6 font-monospace">{ "Emprunt des livres"}</Modal.Title>
                </Modal.Header>
                <Modal.Body className="row">

                    <div className="text-center"><span className="text-danger text-small small">{ this.state.error }</span></div>

                    <div className="form-group col-md-12 mt-2">
                        <label className="font-weight-bolder">Livre</label>
                        <div className="input-group">
                            <Select className="form-control form-control-sm p-0"
                                value = {
                                    optionbooks.filter(option => 
                                    option.value == this.state.bookId)
                                }
                                defaultValue={this.state.bookId}
                                onChange={
                                    (select) => {
                                        this.setState({
                                            bookId : select.value
                                        });
                                    }
                                }
                                options={optionbooks}
                            />
                        </div>
                    </div>

                    <div className="form-group col-md-12 mt-2">
                        <label className="font-weight-bolder">
                            Demandeur
                            (
                                <input type={"checkbox"} className="rounded rounded-2 ms-2" name="isStudent" value={this.state.isStudent} onChange={this.handleInputM} id="staff"/>
                                <label htmlFor="staff" className="me-2">Personnel</label>
                            )
                        </label>
                        <div className={ this.state.isStudent ? "input-group" : "d-none"}>
                            <Select className="form-control form-control-sm p-0"
                                value = {
                                    optionstudents.filter(option => 
                                    option.value == this.state.studentId)
                                }
                                defaultValue={this.state.studentId}
                                onChange={
                                    (select) => {
                                        this.setState({
                                            studentId : select.value
                                        });
                                    }
                                }
                                options={optionstudents}
                            />
                        </div>
                        <div className={ this.state.isStudent ? "d-none" : "input-group"}>
                            <Select className="form-control form-control-sm p-0"
                                value = {
                                    optionstaffs.filter(option => 
                                    option.value == this.state.staffId)
                                }
                                defaultValue={this.state.staffId}
                                onChange={
                                    (select) => {
                                        this.setState({
                                            staffId : select.value
                                        });
                                    }
                                }
                                options={optionstaffs}
                            />
                        </div>
                    </div>

                    <div className="col-md-6 mt-2 mt-2">
                        <div className="form-group has-icon">
                            <label htmlFor="nom-id-icon">Motif</label>
                            <div className="position-relative mt-1">
                                <textarea name="reason" value={this.state.reason} className="form-control form-control-sm" onChange={this.handleInput}></textarea>
                            </div>
                        </div>
                    </div>

                    <div className="col-md-6 mt-2 mt-2 row">
                        <div className="col-md-12 mt-2 mt-2">
                            <div className="form-group has-icon-left">
                                <label htmlFor="nom-id-icon">Date emprunt</label>
                                <div className="position-relative mt-1">
                                    <input type="date" className="form-control form-control-sm" placeholder=""  onChange={this.handleInput} name="date_start"  value={this.state.date_start} id="nom-id-icon" />
                                    <div className="form-control-icon text-primary">
                                        <FeatherIcon icon="calendar"></FeatherIcon>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className="col-md-12 mt-2 mt-2">
                            <div className="form-group has-icon-left">
                                <label htmlFor="nom-id-icon">Date remise</label>
                                <div className="position-relative mt-1">
                                    <input type="date" className="form-control form-control-sm" placeholder=""  onChange={this.handleInput} name="date_end"  value={this.state.date_end} id="nom-id-icon" />
                                    <div className="form-control-icon text-primary">
                                        <FeatherIcon icon="calendar"></FeatherIcon>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>

                </Modal.Body>
                <Modal.Footer>
                    <button onClick={this.props.showModal} className="btn btn-outline-secondary btn-sm p-0 px-1"><FeatherIcon icon="corner-down-left"></FeatherIcon> Fermer</button>
                    <button onClick={() => this.storeBorrow()} className="btn btn-sm btn-outline-primary p-0 px-1"><FeatherIcon icon="check-square"></FeatherIcon> Sauvegarder</button>
                </Modal.Footer>
            </Modal>
            
 
        </div>
        )
    }
}
export default BookForm;